"use strict";

exports.__esModule = true;
var _manifestMappers = require("./manifest-mappers");
Object.keys(_manifestMappers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _manifestMappers[key]) return;
  exports[key] = _manifestMappers[key];
});
//# sourceMappingURL=index.js.map